import { AppStore } from "./AppStore";

export const RootStore = {
  appStore: new AppStore(),
};

export type IRootStore = typeof RootStore;
